<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />
        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Exam Wise Remark Entry </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
              getStandardCourse();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id" item-value="c_id"
                        :items="crs_list" item-text="course" label="Course" outlined
                        @change="getassessmentschemedetails()" persistent-hint hint="Please select course"
                        @click="putnull2" />
                </v-col>
                <v-col cols="12" sm="5" md="5" v-if="assessment_detail_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="assessment_detail" return-object
                        :items="assessment_detail_list" item-text="assessmenttype" label="Assessment Scheme Details"
                        outlined multiple persistent-hint hint="Please select assessment scheme details"
                        @click="putnull3" />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div && crs_id && assessment_detail
          ">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <div v-if="learner_course_list != null && show" class="table-wrapper">
                <div id="my-table-id" class="scroll">
                    <v-simple-table dense class="elevation-1 marks-table">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="col-xs">Sr. No.</th>
                                    <th class="col-xs">Roll No.</th>
                                    <th class="col-sm">Registration No.</th>
                                    <th class="col-name">Name</th>

                                    <!-- Assessment Scheme Column Headers -->
                                    <th
                                        v-for="(header, index) in ass_detail_list"
                                        :key="'header-' + index"
                                    >
                                        {{ header }}
                                    </th>

                                    <th class="col-action">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    v-for="(s, index) in learner_course_list"
                                    :key="s.cid || index"
                                >
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.rollno }}</td>
                                    <td>{{ s.registration_number }}</td>
                                    <td class="name-cell">{{ s.name }}</td>

                                   
<!-- Comment Inputs for each Assessment Scheme column -->
                                <td
                                    v-for="(header, markIndex) in ass_detail_list"
                                    :key="'comment-' + markIndex"
                                    class="comment-cell"
                                >
                                    <!-- Show red message when marks are NA -->
                                    <div
                                        v-if="
                                            s.comp_marks &&
                                            String(s.comp_marks[markIndex]).trim().toUpperCase() === 'NA'
                                        "
                                        class="mark-entry-error"
                                    >
                                        Marks entry not done
                                    </div>

                                    <!-- Show comment box only when marks are available -->
                                    <v-textarea
                                        v-else
                                        v-model="s.remarks_dict[header]"
                                        placeholder="Enter comment..."
                                        rows="2"
                                        auto-grow
                                        outlined
                                        dense
                                        hide-details
                                        class="comment-input"
                                    />
                                </td>

                                    <!-- Action Column -->
                                    <td class="action-cell">
                                        <v-btn
                                            small
                                            rounded
                                            color="#cfd8dc"
                                            class="button"
                                            :loading="savingState[index]"
                                            :disabled="savingState[index] || save_all_loader"
                                            @click="saveRemark(s, index)"
                                        >
                                            {{ s.isSaved ? 'UPDATE' : 'SAVE' }}
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </div>
               <div
                class="text-center mt-4 pb-4"
                v-if="learner_course_list && learner_course_list.length > 0"
            >
                <v-btn
                    class="button"
                    :loading="save_all_loader"
                    :disabled="save_all_loader"
                    @click="saveAllAssessmentComments"
                >
                    Save/Update Comments
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard

    export default {
        
        data() {
            return {
                snackbar: false,
                crs_id: null,
                crs_list: [],
                snackbar_msg: "",
                color: "",
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                course: null,
                ass_detail_list: null,
                learner_course_list: null,
                show: false,
                default_value: null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,

                // Track loading states for individual row save buttons
                savingState: {},
                save_all_loader: false,
            };
        },

        methods: {

            async saveRemark(student, index, silent) {
                if (typeof index !== "undefined") {
                    this.$set(this.savingState, index, true);
                }

                try {
                    const assessments = this.ass_detail_list.map(
                        (header, markIndex) => {
                            const marks =
                                student.comp_marks &&
                                student.comp_marks[markIndex] != null
                                    ? student.comp_marks[markIndex]
                                    : "NA";

                            const recordId =
                                student.all_marks_id &&
                                student.all_marks_id[markIndex] != null
                                    ? student.all_marks_id[markIndex]
                                    : null;

                            const comment =
                                student.remarks_dict &&
                                student.remarks_dict[header] != null
                                    ? student.remarks_dict[header]
                                    : "";

                            return {
                                assessment_id:
                                    recordId === "NA" || recordId === null
                                        ? null
                                        : Number(recordId),
                                marks: marks,
                                comment: comment
                            };
                        }
                    );

                    const payload = {
                        cid: student.cid,
                        crs_id: this.crs_id,
                        ay: this.sel_ay_data.ay_id,
                        sem: this.sem,
                        assessments: assessments
                    };

                    const response = await axios.post(
                        "/Examination/saveLearnerAssessmentMarksComment",
                        payload
                    );

                    if (response.data.flag === "YES") {
                        this.$set(student, "isSaved", true);

                        if (!silent) {
                            this.showSnackbar(
                                "#4caf50",
                                response.data.msg || "Comments saved successfully"
                            );
                        }

                        return true;
                    }

                    if (!silent) {
                        this.showSnackbar(
                            "#b71c1c",
                            response.data.msg || "Failed to save comments"
                        );
                    }

                    return false;

                } catch (error) {
                    console.error("Error saving assessment comments:", error);

                    if (!silent) {
                        this.showSnackbar(
                            "#b71c1c",
                            "Failed to save assessment comments"
                        );
                    }

                    return false;

                } finally {
                    if (typeof index !== "undefined") {
                        this.$set(this.savingState, index, false);
                    }
                }
            },
            
            
async saveAllAssessmentComments() {
    if (!this.learner_course_list || this.learner_course_list.length === 0) {
        this.showSnackbar("#b71c1c", "No learner records found");
        return;
    }

    if (!this.sel_ay_data || !this.sel_ay_data.ay_id ||
        !this.crs_id || !this.sem) {
        this.showSnackbar("#b71c1c", "Please select all required fields");
        return;
    }

    this.save_all_loader = true;

    try {
        const learners = this.learner_course_list.map(student => ({
            cid: student.cid,
            assessments: this.ass_detail_list.map((header, markIndex) => {
                const marks =
                    student.comp_marks &&
                    student.comp_marks[markIndex] != null
                        ? student.comp_marks[markIndex]
                        : "NA";

                const recordId =
                    student.all_marks_id &&
                    student.all_marks_id[markIndex] != null
                        ? student.all_marks_id[markIndex]
                        : null;

                return {
                    assessment_id:
                        recordId == null ||
                        String(recordId).trim().toUpperCase() === "NA"
                            ? null
                            : Number(recordId),
                    marks: marks,
                    comment:
                        student.remarks_dict &&
                        student.remarks_dict[header] != null
                            ? student.remarks_dict[header]
                            : ""
                };
            })
        }));

        const payload = {
            crs_id: this.crs_id,
            ay: this.sel_ay_data.ay_id,
            sem: this.sem,
            learners: learners
        };

        console.log("Bulk assessment comment payload:", payload);

        const response = await axios.post(
            "/Examination/saveLearnerAssessmentMarksComment",
            payload
        );

        if (response.data.flag === "YES") {
            this.showSnackbar(
                "#4caf50",
                response.data.msg || "Assessment comments saved successfully"
            );
        } else {
            this.showSnackbar(
                "#b71c1c",
                response.data.msg || "Failed to save assessment comments"
            );
            console.log("Backend response:", response.data);
        }
    } catch (error) {
        console.error("Error saving assessment comments:", error);
        this.showSnackbar("#b71c1c", "Failed to save assessment comments");
    } finally {
        this.save_all_loader = false;
    }
},




            myfunction() {
                for (var i = 0; i < this.learner_course_list.length; i++) {
                    var formattter = Math.round(this.learner_course_list[i].converted_marks);
                }
            },
            putnull3() {
                this.show = false;
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            putnull2() {
                this.assessment_detail_list = [];
                this.assessment_detail = null;
            },
            
getreport() {
    if (
        !this.sel_ay_data ||
        !this.sel_std_data ||
        !this.div ||
        !this.crs_id ||
        !this.sem ||
        !this.assessment_detail ||
        !this.status
    ) {
        this.showSnackbar(
            "#b71c1c",
            "Please select all required fields"
        );
        return;
    }

    const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        crs_id: this.crs_id,
        sem: this.sem,
        div: this.div,
        ass_id: this.assessment_detail,
        status: this.status
    };

    this.fetch_loader = true;

    axios
        .post("/Examination/getsubjectconsolidatedreport", data)
        .then((res) => {
            if (res.data.flag === "YES" || res.data.flag === "NO") {
                this.standard = res.data.standard;
                this.division = res.data.div;
                this.course = res.data.course;
                this.ass_Scheme = res.data.ass_Scheme;
                this.academicyear = res.data.ay;

                this.ass_detail_list = res.data.ass_detail_list || [];
                this.learner_course_list =
                    res.data.learner_course_list || [];

                this.default_value = res.data.default_value;

                // Initialize saved comments for every learner
                this.learner_course_list.forEach((student) => {
                    this.$set(student, "remarks_dict", {});

                    let hasExistingRemarks = false;

                    this.ass_detail_list.forEach((header, markIndex) => {
                        const savedComment =
                            student.all_marks_comment &&
                            student.all_marks_comment[markIndex] != null
                                ? String(
                                      student.all_marks_comment[markIndex]
                                  )
                                : "";

                        this.$set(
                            student.remarks_dict,
                            header,
                            savedComment
                        );

                        if (savedComment.trim() !== "") {
                            hasExistingRemarks = true;
                        }
                    });

                    this.$set(student, "isSaved", hasExistingRemarks);
                });

                // Apply rounding configuration
                if (this.default_value === "True") {
                    this.learner_course_list.forEach((student) => {
                        student.converted_marks = Math.round(
                            Number(student.converted_marks) || 0
                        );

                        student.levaluated_marks = Math.round(
                            Number(student.levaluated_marks) || 0
                        );
                    });
                }

                this.inst_name = res.data.inst_name;
                this.atotal = res.data.atotal;
                this.ass_converted_total = res.data.ass_converted_total;
                this.org_basic_data = res.data.org_basic_data;

                this.show = true;

                if (res.data.flag === "NO") {
                    this.showSnackbar(
                        "#b71c1c",
                        res.data.msg_flag || "Unable to fetch report"
                    );
                }
            } else {
                this.showSnackbar(
                    "#b71c1c",
                    res.data.msg || "Unable to fetch report"
                );
            }
        })
        .catch((error) => {
            console.error("Error fetching subject consolidated report:", error);

            this.showSnackbar(
                "#b71c1c",
                "Something went wrong while fetching the report"
            );
        })
        .finally(() => {
            this.fetch_loader = false;
        });
},

            getassessmentschemedetails() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getassessmentschemewithoutrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => { });
            },
            getStandardCourse() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                };
                axios
                    .post("/Examination/getStandardCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => { });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => { });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>

<style scoped>
.box {
    margin: 10px;
    padding: 12px;
    border-radius: 5px;
    width: calc(100% - 20px) !important;
}

/* Outer Table Wrapper */
.table-wrapper,
.scroll,
#my-table-id {
    width: 100% !important;
    max-width: 100% !important;
    display: block !important;
    margin-top: 15px;
    box-sizing: border-box;
}

/* Force Table Width */
.marks-table {
    width: 100% !important;
    min-width: 100% !important;
    border: 1px solid #d3d3d3 !important;
    border-collapse: collapse !important;
    box-shadow: none !important;
}

.marks-table ::v-deep .v-data-table__wrapper {
    width: 100% !important;
    overflow-x: auto !important;
}

.marks-table ::v-deep table {
    width: 100% !important;
    min-width: 100% !important;
    table-layout: auto !important;
    border-collapse: collapse !important;
}

/* Column Width Adjustments */
.marks-table ::v-deep th.col-xs {
    width: 5%;
}

.marks-table ::v-deep th.col-sm {
    width: 10%;
}

.marks-table ::v-deep th.col-name {
    width: 18%;
}

.marks-table ::v-deep th.col-action {
    width: 10%;
}

/* Header Styling */
.marks-table ::v-deep thead th {
    background-color: #1e3a45 !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    font-size: 13px !important;
    text-align: center !important;
    padding: 10px 6px !important;
    border: 1px solid #2d505c !important;
    height: 40px !important;
    white-space: nowrap !important;
}

/* Body Cells */
.marks-table ::v-deep tbody td {
    padding: 8px 6px !important;
    font-size: 13px !important;
    color: #2c3e50 !important;
    text-align: center !important;
    border: 1px solid #d0d7de !important;
    vertical-align: middle !important;
}

/* Zebra Striping */
.marks-table ::v-deep tbody tr:nth-child(even) {
    background-color: #f8f9fa !important;
}

.marks-table ::v-deep tbody tr:nth-child(odd) {
    background-color: #ffffff !important;
}

/* Row Hover */
.marks-table ::v-deep tbody tr:hover {
    background-color: #ebf1f5 !important;
}

/* Name Alignment */
.marks-table ::v-deep .name-cell {
    text-align: center !important;
    font-weight: 500;
}

/* Comment Field Container */
.marks-table ::v-deep .comment-cell {
    padding: 8px !important;
    min-width: 180px;
}

/* Rounded Input Style */
.marks-table ::v-deep .comment-input .v-input__control .v-input__slot {
    background-color: #ffffff !important;
    border-radius: 8px !important;
    min-height: 40px !important;
    font-size: 13px !important;
    box-shadow: none !important;
}

.marks-table ::v-deep .comment-input textarea {
    line-height: 1.4 !important;
    padding: 4px 0 !important;
}

/* Action Button Cell */
.marks-table ::v-deep .action-cell {
    text-align: center !important;
}

.marks-table ::v-deep .button {
    font-weight: 600 !important;
    letter-spacing: 0.5px !important;
    font-size: 11px !important;
    color: #37474f !important;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15) !important;
}

/* Responsive Support */
@media (min-width: 320px) {
    .marks-table ::v-deep td,
    .marks-table ::v-deep th {
        display: table-cell !important;
    }
}

/* Utility / Page Styling */
.radiospace {
    margin: 1rem !important;
    padding: 0;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    box-shadow: none !important;
    background-color: #ffffff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    box-shadow: none !important;
    background-color: #ffffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem !important;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880px;
    right: 0;
}

.trust-logo {
    width: 50%;
    padding-right: 10px;
}

.schl-logo {
    width: 50%;
    padding-left: 10px;
}

/* Print Styling */
@media print {
    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    tr,
    th,
    td {
        break-inside: avoid-page;
        border: 1px solid #000000 !important;
        text-align: center !important;
        font-size: 14pt !important;
        font-weight: bold !important;
        padding: 4px !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .table-wrapper,
    .scroll {
        height: auto !important;
        overflow: visible !important;
    }

    @page {
        size: A4 landscape;
        margin: 10mm;
    }
}

.v-card {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
}
.mark-entry-error {
    color: #d32f2f !important;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    margin-top: 6px;
    white-space: normal;
}
</style>